import CategoryList from "../../../components/AdminComponents/category/CategoryList.jsx";

const Category = () => {
  return (
    <>
      <div className="flex h-screen">
        <CategoryList />
      </div>
    </>
  );
};

export default Category;
